import React from "react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/393463785564?text=Ciao%2C%20vorrei%20richiedere%20un%20preventivo%20per%20la%20pulizia%20del%20mio%20divano."
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      aria-label="Contattaci su WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="30"
        height="30"
        fill="white"
      >
        <path d="M16.003 0C7.17 0 .003 7.163.003 15.997c0 2.824.74 5.566 2.143 7.976L0 32l8.246-2.11A15.957 15.957 0 0016.003 32C24.836 32 32 24.837 32 16.003 32 7.167 24.836 0 16.003 0zm0 29.25a13.22 13.22 0 01-6.74-1.844l-.484-.287-5.006 1.28 1.305-4.862-.318-.5A13.188 13.188 0 012.75 16.003c0-7.31 5.946-13.25 13.253-13.25 7.307 0 13.25 5.94 13.25 13.25 0 7.307-5.943 13.247-13.25 13.247zm7.27-9.927c-.4-.198-2.36-1.16-2.726-1.29-.366-.133-.633-.198-.9.2-.265.4-1.03 1.29-1.263 1.558-.232.265-.465.298-.864.1-.4-.198-1.686-.62-3.21-1.974-1.186-1.055-1.988-2.36-2.22-2.757-.233-.4-.025-.614.174-.813.18-.178.4-.465.6-.698.198-.233.264-.4.397-.665.132-.265.066-.498-.033-.697-.1-.198-.9-2.163-1.233-2.96-.324-.78-.653-.674-.9-.686l-.764-.013c-.265 0-.697.1-1.063.498-.366.4-1.397 1.364-1.397 3.327 0 1.963 1.43 3.86 1.63 4.127.197.265 2.814 4.297 6.818 6.026.954.41 1.697.655 2.277.837.957.304 1.828.261 2.516.158.767-.114 2.36-.963 2.693-1.893.332-.93.332-1.727.232-1.893-.1-.166-.366-.265-.764-.465z" />
      </svg>
    </a>
  );
}
